import moment from "moment";
import { poster } from "../utils/axios";
import { clearFinishedExamData } from "../utils/examStorageCleaner";
import { examUrlParams } from "../utils/urlParams";
import { KEYS } from "../constants/storageKeys";

export async function getExamAndSchedules(updateActiveView) {
  const savedToken = sessionStorage.getItem(KEYS.EXAM_SESSION_TOKEN);
  const { productId: examId, uprId, productType } = examUrlParams;

  const payload = savedToken
    ? { resume: true, sessionToken: savedToken, examId, uprId, productType }
    : { resume: false, examId, uprId, productType };

  try {
    const response = await poster(`exam/examTimingDetails`, payload);
    const { status, data } = response;

    if (status === 400) {
      if (data.error === "Exam has not started yet") {
        updateActiveView("examNotStarted");
      } else if (data.error === "Exam finished waiting feedback") {
        updateActiveView("examFinish");
        clearFinishedExamData();
      } else if (data.error === "Exam has ended") {
        updateActiveView("examExpired");
        clearFinishedExamData();
      } else {
        updateActiveView("unknownException");
      }
    } else if (status === 404) {
      console.log("404 Error: Exam not found");
      updateActiveView("notFound");
    } else if (status === 500) {
      updateActiveView("unknownException");
    }

    return response;
  } catch (error) {
    console.error("Network/server error:", error);
    updateActiveView("unknownException");
    throw error;
  }
}

export async function manageExamSections(
  updateActiveView,
  updateStageTimeLeft,
  isDemoExam,
  productType,
  activeView,
  examType,
  isManualSubmit,
  setIsManualSubmit,
  examAndSchedules
) {
  try {
    const finished =
      examType === "free-practice"
        ? await managePracticeExam()
        : ["reading", "listening", "writing"].includes(productType)
          ? await manageSectionPracticeTest()
          : isDemoExam
            ? await manageDemoExam()
            : await manageExam(examAndSchedules);


    ["reading", "listening", "writing"].includes(productType) || examType == "free-practice"
      ? await changePracticeStages(finished)
      : await changeStages(finished);

    if (finished) return;
  } catch (error) {
    console.error("Failed to start exam:", error);
  }

  // Shared timer+stage logic
  // async function timeStageManagerForOtherTypeExams(schedulesFactory, finishedStageName) {
  //   let currentTime;
  //   const params = new URLSearchParams(window.location.search);
  //   const scratch = params.get("scratch");
  //   const visited = sessionStorage.getItem("visitedFromA");

  //   if (scratch === "true" && !visited) {
  //     localStorage.removeItem("examinax-demoCurrentTime");
  //     sessionStorage.setItem("visitedFromA", "true");
  //     params.delete("scratch");
  //     window.history.replaceState(
  //       {},
  //       "",
  //       window.location.pathname +
  //       (params.toString() ? "?" + params.toString() : "")
  //     );
  //   }

  //   const saved = localStorage.getItem("examinax-demoCurrentTime");
  //   currentTime = saved ? moment.utc(saved) : moment.utc();
  //   if (!saved)
  //     localStorage.setItem("examinax-demoCurrentTime", currentTime.toISOString());

  //   const examSchedulesIncludedData = schedulesFactory(currentTime);
  //   const endTime = examSchedulesIncludedData.endTime;

  //   if (moment.utc().isAfter(endTime)) {
  //     localStorage.removeItem("examinax-demoCurrentTime");
  //     updateActiveView(finishedStageName);
  //     return true;
  //   }
  //   return examSchedulesIncludedData;
  // }

  async function timeStageManagerForOtherTypeExams(
    schedulesFactory,
    finishedStageName
  ) {
    let currentTime;
    const { scratch } = examUrlParams;
    const visited = sessionStorage.getItem(KEYS.VISITED_FROM_A);

    if (scratch === "true" && !visited) {
      sessionStorage.removeItem(KEYS.DEMO_CURRENT_TIME);
      sessionStorage.setItem(KEYS.VISITED_FROM_A, "true");
      // Remove scratch param from URL bar
      const params = new URLSearchParams(window.location.search);
      params.delete("scratch");
      window.history.replaceState(
        {},
        "",
        window.location.pathname +
        (params.toString() ? "?" + params.toString() : "")
      );
    }

    const saved = sessionStorage.getItem(KEYS.DEMO_CURRENT_TIME);
    currentTime = saved ? moment.utc(saved) : moment.utc();

    if (!saved)
      sessionStorage.setItem(KEYS.DEMO_CURRENT_TIME, currentTime.toISOString());

    const examSchedulesIncludedData = schedulesFactory(currentTime);
    const endTime = examSchedulesIncludedData.endTime;

    if (moment.utc().isAfter(endTime)) {
      sessionStorage.removeItem(KEYS.DEMO_CURRENT_TIME);
      updateActiveView(finishedStageName);
      return true;
    }
    return examSchedulesIncludedData;
  }

  async function practiceTimeStageManager(sectionDurations) {
    const storedActiveView = sessionStorage.getItem(KEYS.ACTIVE_VIEW);
    const storedStart = sessionStorage.getItem(KEYS.SECTION_STARTED_AT);
    const storedDuration = Number(sessionStorage.getItem(KEYS.DURATION));

    if (storedActiveView) {
      const currentIndex = sectionDurations.findIndex(s => s.sectionType === storedActiveView);

      // Manual submit: force next section regardless of remaining time
      if (isManualSubmit) {
        const nextSection = sectionDurations[currentIndex + 1];
        if (nextSection) {
          sessionStorage.setItem(KEYS.ACTIVE_VIEW, nextSection.sectionType);
          sessionStorage.setItem(KEYS.DURATION, nextSection.duration);
          sessionStorage.setItem(KEYS.SECTION_STARTED_AT, moment.utc().toISOString());

          // Reset manual submit flag
          setIsManualSubmit(false);

          return {
            name: "IELTS Practice",
            startTime: moment.utc(),
            endTime: moment.utc().add(nextSection.duration, "minutes"),
            remainingSection: nextSection,
          };
        } else {
          // No more sections — exam finished
          // sessionStorage.setItem(KEYS.ACTIVE_VIEW, "practiceFinished");
          // sessionStorage.removeItem(KEYS.DURATION);
          // sessionStorage.removeItem(KEYS.SECTION_STARTED_AT);
          console.log("Manual Submit ELse");

          updateActiveView("practiceFinished");
          return;
          // return {
          //   name: "IELTS Practice",
          //   startTime: moment.utc(),
          //   endTime: moment.utc(),
          //   remainingSection: null,
          // };
        }
      }

      // Normal resume flow
      if (storedStart && storedDuration) {
        const startedAt = moment.utc(storedStart);
        const now = moment.utc();
        const endAt = startedAt.clone().add(storedDuration, "minutes");
        const timeLeft = endAt.diff(now, "seconds");

        if (timeLeft > 0) {
          updateActiveView(storedActiveView);
          updateStageTimeLeft(timeLeft);
          return {
            name: "IELTS Practice",
            startTime: startedAt,
            endTime: endAt,
            remainingSection: {
              sectionType: storedActiveView,
              duration: storedDuration,
            }
          };
        }
      }

      // Expired section, go to next
      const nextSection = sectionDurations[currentIndex + 1];
      if (nextSection) {
        sessionStorage.setItem(KEYS.ACTIVE_VIEW, nextSection.sectionType);
        sessionStorage.setItem(KEYS.DURATION, nextSection.duration);
        sessionStorage.setItem(KEYS.SECTION_STARTED_AT, moment.utc().toISOString());


        return {
          name: "IELTS Practice",
          startTime: moment.utc(),
          endTime: moment.utc().add(nextSection.duration, "minutes"),
          remainingSection: nextSection,
        };
      } else {
        sessionStorage.setItem(KEYS.ACTIVE_VIEW, "practiceFinished");
        sessionStorage.removeItem(KEYS.DURATION);
        sessionStorage.removeItem(KEYS.SECTION_STARTED_AT);

        updateActiveView("practiceFinished");
        return {
          name: "IELTS Practice",
          startTime: moment.utc(),
          endTime: moment.utc(),
          remainingSection: null,
        };
      }
    }

    // Default fallback if nothing stored yet (fresh start)
    const firstSection = sectionDurations[0];
    sessionStorage.setItem(KEYS.ACTIVE_VIEW, firstSection.sectionType);
    sessionStorage.setItem(KEYS.DURATION, firstSection.duration);
    sessionStorage.setItem(KEYS.SECTION_STARTED_AT, moment.utc().toISOString());

    return {
      name: "IELTS Practice",
      startTime: moment.utc(),
      endTime: moment.utc().add(firstSection.duration, "minutes"),
      remainingSection: firstSection,
    };
  }

  // PRACTICE
  async function managePracticeExam(sectionDurations) {
    // console.log('managePracticeExam');

    const sectionMap = [
      { sectionType: "listeningIntro", duration: 60 },
      { sectionType: "listening", duration: 1800 },
      { sectionType: "readingIntro", duration: 60 },
      { sectionType: "reading", duration: 3600 },
      // { sectionType: "writingIntro", duration: 60 },
      // { sectionType: "writing", duration: 3600 },
    ];


    sectionMap.push({ sectionType: "practiceFinished", duration: 0 })

    return await practiceTimeStageManager(sectionMap)
  }

  // SECTION PRACTICE TEST
  async function manageSectionPracticeTest() {

    const sectionMap = {
      listening: [
        { sectionType: "listeningIntro", duration: 60 },
        { sectionType: "listening", duration: 1800 },
      ],
      reading: [
        { sectionType: "readingIntro", duration: 60 },
        { sectionType: "reading", duration: 3600 },
      ],
      writing: [
        { sectionType: "writingIntro", duration: 60 },
        { sectionType: "writing", duration: 3600 },
      ],
    };

    const sectionDurations = sectionMap[productType] || [];

    sectionDurations.push({ sectionType: "practiceFinished", duration: 0 })

    return await practiceTimeStageManager(sectionDurations)
  }

  // DEMO
  async function manageDemoExam() {
    // console.log("Demo Exam");
    return timeStageManagerForOtherTypeExams(
      (currentTime) => ({
        name: "IELTS Demo",
        startTime: currentTime,
        endTime: currentTime.clone().add(6, "minutes"),
        schedules: [
          {
            sectionType: "listening",
            startTime: currentTime
              .clone()
              .add(5, "seconds")
              .subtract(1, "seconds"),
            endTime: currentTime.clone().add(2, "minutes"),
          },
          {
            sectionType: "reading",
            startTime: currentTime.clone().add(3, "minutes"),
            endTime: currentTime.clone().add(4, "minutes"),
          },
          {
            sectionType: "writing",
            startTime: currentTime.clone().add(5, "minutes"),
            endTime: currentTime.clone().add(6, "minutes"),
          },
        ],
      }),
      "demoFinished"
    );
  }


  //PAID STRICT TIME EXAM
  async function manageExam(examAndSchedules) {
    const { data } = examAndSchedules;

    // if (examData.sessionToken) {
    //   sessionStorage.setItem("examSessionToken", examData.sessionToken);
    // } else {
    //   console.warn("No session token in response");
    // }
    return data.exam;

  }

  //STAGE MANAGEMENT
  async function changeStages(exam) {
    // console.log("> Change Stage");

    const data = exam;
    try {
      if (!data || !data.schedules || data.schedules.length === 0) {
        return;
      }

      const momentSchedules = data.schedules.map((schedule) => ({
        sectionType: schedule.sectionType,
        startTime: moment.utc(schedule.startTime),
        endTime: moment.utc(schedule.endTime),
      }));

      // console.log("momentSchedules", momentSchedules);

      const serverTimeResponse = (await fetch(
        `${process.env.REACT_APP_API_URL}/server-time`
      )).json();

      const currentTime = moment.utc(serverTimeResponse.serverTime);
      let activeStageLeftTime;
      const examStartTime = moment.utc(data.startTime);
      let activeView;

      for (let i = 0; i < momentSchedules.length; i++) {
        const { startTime, endTime, sectionType } = momentSchedules[i];
        const nextSchedule = momentSchedules[i + 1];

        // console.log(currentTime.toISOString());
        // console.log(startTime.toISOString());
        // console.log(endTime.toISOString());

        if (currentTime.isBetween(startTime, endTime, null, "[)")) {
          activeView = sectionType;
          activeStageLeftTime = endTime - currentTime;

          setIsManualSubmit(false)
          break;
        }

        if (
          currentTime.isBefore(startTime)
        ) {
          activeView = sectionType + "Intro";
          activeStageLeftTime = startTime - currentTime;

          setIsManualSubmit(false)
          break;
        }

        if (nextSchedule == undefined && currentTime.isAfter(endTime)) {
          activeView = "examFinish";
        }
      }
      // console.log(">>>> Change Stage activeView", activeView);

      updateActiveView(activeView);
      updateStageTimeLeft(activeStageLeftTime / 1000 + 1);
      updateActiveView(activeView);

    } catch (error) {
      console.error("Failed to start exam:", error);
    }
  }



  async function changePracticeStages(exam) {
    // console.log("> Change Practice Stage");

    const data = exam.remainingSection;
    if (!data) return;
    try {
      const activeView = data.sectionType;

      sessionStorage.setItem(KEYS.ACTIVE_VIEW, activeView)

      updateActiveView(activeView);
      updateStageTimeLeft(data.duration);
      updateActiveView(activeView);

    } catch (error) {
      console.error("Failed to start exam:", error);
    }
  }
}

// Re-export cleanup functions from centralized module for backward compatibility.
// New code should import directly from utils/examStorageCleaner.
export {
  clearFinishedExamData as clearFinishedExamDataFromBrowser,
  clearSectionAnswers as clearSectionAnswersFromBrowser,
  clearListeningAudio as clearListeningAudioFromIndexDB,
} from "../utils/examStorageCleaner";
